var DEFAULT_MARGIN_TOP_INDICATOR_DESKTOP = 4;
var DEFAULT_MARGIN_TOP_INDICATOR_MOBILE = 0;
export var calculateMarginTopIndicator = function calculateMarginTopIndicator(_ref) {
  var isMobile = _ref.isMobile,
    isMultiLine = _ref.isMultiLine,
    indicatorPosition = _ref.indicatorPosition,
    marginTopIndicator = _ref.marginTopIndicator;
  if (indicatorPosition === 'center' || !isMultiLine && indicatorPosition !== 'top') {
    return 0;
  }
  if (marginTopIndicator !== undefined) {
    return marginTopIndicator;
  }
  return isMobile ? DEFAULT_MARGIN_TOP_INDICATOR_MOBILE : DEFAULT_MARGIN_TOP_INDICATOR_DESKTOP;
};